/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import NavigationModeMenu, { NavigationModeMenuStyles } from "@insite/content-library/Components/NavigationModeMenu";
import Hidden from "@insite/mobius/Hidden";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import * as cssLinter from "css";
// import React, { FC } from "react"; // Valtech Custom Code
import { connect } from "react-redux";
// import styled, { css } from "styled-components"; // Valtech Custom Code

/* Valtech Custom Code */
import { ShellContext } from "@insite/client-framework/Components/IsInShell";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { useIsSignedIn } from "@store/Hooks/Common";
import { CartLinkProps } from "@store/Overrides/Widgets/Common/CartLink";
import { HeaderSignInProps } from "@store/Overrides/Widgets/Common/HeaderSignIn";
import { TYPOGRAPHY } from "@store/theme/design";
import { siteWidthStyles, transitionHoverStyles } from "@store/theme/mixins";
import { WithShellContext } from "@store/Types/Shell";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import React, { FC, useContext } from "react";
import styled, { css, withTheme } from "styled-components";

const HeaderSignIn = getWidgetComponent("Common/HeaderSignIn");
const CartLink = getWidgetComponent("Common/CartLink");
export const SECONDARY_NAVIGATION_HEIGHT = 45;

const StyledContainer = styled(StyledWrapper)<WithShellContext>``;
/* Valtech Custom Code */

const enum fields {
    customCSS = "customCSS",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.customCSS]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    enableWarehousePickup: getSettingsCollection(state).accountSettings.enableWarehousePickup,
});

/* Valtech Custom Code */
interface OwnProps extends WidgetProps {
    theme: BaseTheme;
}
/* Valtech Custom Code */
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const Navigation = styled.div`
    color: ${getContrastColor("common.accent")};
    font-size: 15px;
    background-color: ${getColor("common.accent")};
    padding: 0 45px 0 45px;
    height: 50px;
    text-transform: uppercase;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const NavItem = styled.span<InjectableCss>`
    display: inline-flex;

    > span,
    > a {
        margin-left: 10px;
    }
    ${injectCss}
`;

export interface SecondaryNavigationStyles {
    wrapper?: InjectableCss;
    navigationModeMenu?: NavigationModeMenuStyles;
    languageLink?: InjectableCss;
    warehousePickupLink?: InjectableCss;
    signInLink?: InjectableCss;
    // Valtech Custom Code
    container?: InjectableCss;
    subWrapper?: InjectableCss;
}

export const secondaryNavigationStyles: SecondaryNavigationStyles = {
    container: {
        css: css<WithShellContext>`
            background-color: ${getColor("secondary")};
            color: ${getContrastColor("secondary")};
            font-size: ${TYPOGRAPHY.size.smallest};
            height: ${SECONDARY_NAVIGATION_HEIGHT}px;
            ${props => (props.shellContext?.isEditing ? "height: auto;" : null)}
            ${props => {
                if (!props.shellContext?.isEditing && props.shellContext?.isInShell) {
                    return `
                        [data-widget] {
                            height: 100%;
                        }
                    `;
                }
            }}
        `,
    },
    wrapper: {
        css: css`
            ${siteWidthStyles()}
            display: flex;
            justify-content: space-between;
            height: inherit;
        `,
    },
    subWrapper: {
        css: css`
            display: flex;
            flex-shrink: 0;
            margin: 0 1.4em;

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        `,
    },
};

const titleClickableStyles = () => {
    return css`
        display: flex;
        background-color: ${getColor("secondary.dark")};
        transition: ${transitionHoverStyles()};

        &:hover,
        &:active,
        &:focus {
            background-color: ${getColor("primary")};
        }
    `;
};

const headerSignInProps: HeaderSignInProps = {
    fields: {
        visibilityState: "both",
        icon: "User",
        includeAccountMenu: true,
    },
    extendedStyles: {
        titleIcon: {
            css: css`
                margin-right: 0.25em;
            `,
        },
        titleClickable: {
            css: css`
                ${titleClickableStyles()}
                padding: 10px 12px;
            `,
        },
        titleClickableLoginOnly: {
            css: css`
                ${titleClickableStyles()}
                padding: 10px 18px 10px 12px;
            `,
        },
        titleSubTypography: {
            css: css`
                margin-left: 0.5em;
            `,
        },
        popover: {
            contentBodyProps: {
                css: css`
                    margin-top: 1px;
                `,
            },
        },
    },
};
/* Valtech Custom Code */

const defaultCustomCss = `.wrapper {
}

.navigation-mode-menu {
}

.currency-menu {
}

.language-menu {
}

.ship-to-address-menu {
}

.sign-in-link {
}`;

// Valtech Custom Code
const SecondaryNavigation: FC<Props> = ({ id, enableWarehousePickup, fields, theme }) => {
    const styles = useMergeStyles("secondaryNavigation", secondaryNavigationStyles);

    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
        `,
    };

    const isSignedIn = useIsSignedIn();
    const shellContext = useContext(ShellContext);

    /* Valtech Custom Code */
    const cartLinkProps: CartLinkProps = {
        fields: {
            visibilityState: "both",
            icon: "cart",
        },
        extendedStyles: {},
        theme,
    };
    /* Valtech Custom Code */

    return (
        <StyledContainer {...styles.container} shellContext={shellContext}>
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.subWrapper}>
                    <Zone zoneName="Left" contentId={id} />
                </StyledWrapper>
                <StyledWrapper {...styles.subWrapper}>
                    <Zone zoneName="Right" contentId={id} />
                    <StyledWrapper {...styles.subWrapper}>
                        <HeaderSignIn {...headerSignInProps} />
                        {isSignedIn && <CartLink {...cartLinkProps} />}
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledContainer>
    );
};
/* Valtech Custom Code */

const secondaryNavigation: WidgetModule = {
    component: connect(mapStateToProps)(withTheme(SecondaryNavigation)), // Valtech Custom Code
    definition: {
        group: "Common",
        icon: "link-simple",
        fieldDefinitions: [
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default secondaryNavigation;
